import Guid from "_shared/guids/guid";
import MarketplaceResponseAPIResponse from "marketplace/_api/response-contracts/marketplace-response-api-response";
import TeamProfile from "marketplace/team-profile/team-profile";
import MarketplaceCompanyInfoAPIResponse from "marketplace/companies/profiles/_api/response-contracts/marketplace-company-info-api-response";
import MarketplaceIndividualInfoAPIResponse from "marketplace/individuals/profiles/_api/response-contracts/marketplace-individual-info-api-response";
import MarketplaceTeam from "marketplace/teams/team";

export default class MarketplaceTeamInfoAPIResponse extends MarketplaceResponseAPIResponse {
  name?: string;
  description?: string;
  leader?: MarketplaceIndividualInfoAPIResponse;
  members?: MarketplaceIndividualInfoAPIResponse[];
  associatedFirms?: MarketplaceCompanyInfoAPIResponse[];
  categories?: string[];
  avatar?: string;

  constructor(init?: Partial<MarketplaceTeamInfoAPIResponse>) {
    super();
    Object.assign(this, init);
  }

  public deserializeToTeam(): MarketplaceTeam {
    const id = Guid.fromJSON(this.id);
    if (!id) {
      throw new Error("Team ID is required, was not returned by the API");
    }
    if (!this.name) {
      throw new Error("Team name is required, was not returned by the API");
    }
    const profile = TeamProfile.fromJSON({
      ...this,
      name: this.name
    });

    const leader = Object.assign(new MarketplaceIndividualInfoAPIResponse(), this.leader).deserialize();
    if (!leader) {
      throw new Error("Team leader is required, was not returned by the API");
    }
      
    return new MarketplaceTeam({
      id,
      leader,
      profile,
      isVisible: this.isVisible ?? false,
      members: (this.members ?? []).map((memberInfo) => {
        const member = Object.assign(new MarketplaceIndividualInfoAPIResponse(), memberInfo).deserialize();
        if (!member)
          throw new Error("Team member could not be deserialized from API response");
        return member;
      }),
      associatedFirms: (this.associatedFirms ?? []).map((companyInfo) => {
        const company = Object.assign(new MarketplaceCompanyInfoAPIResponse(), companyInfo).deserializeToProfile();
        if (!company)
          throw new Error("Associated firm could not be deserialized from API response");
        return company;
      }),
    });
  }
}
